var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4747_378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1619 73.0314H12.3672C7.43905 73.0314 3.46094 69.0533 3.46094 64.1251V11.8753C3.46094 6.94717 7.43905 2.96905 12.3672 2.96905H48.8629C53.791 2.96905 57.7691 6.94717 57.7691 11.8753V20.643",
    stroke: "#215250",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2695 20.7815H45.9122",
    stroke: "#215250",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1133 32.6565H34.3164",
    stroke: "#215250",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4102 44.5315H33.881",
    stroke: "#215250",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9375 60.5839L61.0352 45.7782V33.1115",
    stroke: "#EA7F4A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6476 61.4861H39.2631L36.2422 67.6958L41.9485 72.5629H68.6336L73.6686 66.1853L70.6476 61.4861Z",
    fill: "#EA7F4A",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1914 32.6565H64.1622",
    stroke: "#EA7F4A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7485 61.1564H71.286L72.8693 63.4126C73.8984 65.1147 73.6412 67.3116 72.236 68.7168L69.1485 71.7845C68.337 72.596 67.2485 73.0314 66.1006 73.0314H43.6766C42.5287 73.0314 41.4402 72.596 40.6287 71.7845L37.5412 68.697C36.136 67.2918 35.8788 65.0949 36.9079 63.3929L38.4912 61.1366L49.0204 45.7585V33.0919",
    stroke: "#EA7F4A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8789 33.6252C15.417 33.6252 15.8477 33.1946 15.8477 32.6565C15.8477 32.127 15.4059 31.6877 14.8789 31.6877C14.3408 31.6877 13.9102 32.1184 13.9102 32.6565C13.9102 33.1946 14.3408 33.6252 14.8789 33.6252Z",
    fill: "black",
    stroke: "#215250",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8789 21.7502C15.417 21.7502 15.8477 21.3196 15.8477 20.7815C15.8477 20.252 15.4059 19.8127 14.8789 19.8127C14.3408 19.8127 13.9102 20.2434 13.9102 20.7815C13.9102 21.3196 14.3408 21.7502 14.8789 21.7502Z",
    fill: "black",
    stroke: "#215250",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0195 45.5002C15.5577 45.5002 15.9883 45.0696 15.9883 44.5315C15.9883 43.9934 15.5577 43.5627 15.0195 43.5627C14.4814 43.5627 14.0508 43.9934 14.0508 44.5315C14.0508 45.0696 14.4814 45.5002 15.0195 45.5002Z",
    fill: "black",
    stroke: "#215250",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4747_378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white",
    transform: "translate(0.472656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabReportIcon);
export default __webpack_public_path__ + "static/media/lab-report-icon.9a8103ee1c95992e151ba3a452ff7be4.svg";
export { ForwardRef as ReactComponent };